"use client";

import { c as _c } from "react/compiler-runtime";
import "@/components/calendar/css/calendar.css";
import useContainerWidth from "@/hooks/use-container-width";
import { logger } from "@/utils/logger";
import clsx from "clsx";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-big-calendar";
import { ViewType } from "..";
import { SlotComponentProps } from "../availabilities";
import Calendar from "../calendar-view";
import { SlotComponent } from "../common/slot-component";
import { SlotTableLegend } from "../common/slot-table-legend";
import { TitleComp } from "./title-comp";
import { Slot, SlotContainerProps } from "./types";

// Slot Container Component
export function SlotContainer(t0) {
  const $ = _c(125);
  let TableLegend;
  let Title;
  let buyerSlots;
  let className;
  let counterSlots;
  let defaultView;
  let onChange;
  let onClick;
  let prefill;
  let projectId;
  let props;
  let selectCallback;
  let t1;
  let unitId;
  let viewCounts;
  if ($[0] !== t0) {
    ({
      onChange,
      onClick,
      selectCallback,
      unitId,
      defaultView,
      prefill,
      counterSlots,
      viewCounts,
      buyerSlots,
      TableLegend,
      Title,
      minSlots: t1,
      projectId,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = TableLegend;
    $[2] = Title;
    $[3] = buyerSlots;
    $[4] = className;
    $[5] = counterSlots;
    $[6] = defaultView;
    $[7] = onChange;
    $[8] = onClick;
    $[9] = prefill;
    $[10] = projectId;
    $[11] = props;
    $[12] = selectCallback;
    $[13] = t1;
    $[14] = unitId;
    $[15] = viewCounts;
  } else {
    TableLegend = $[1];
    Title = $[2];
    buyerSlots = $[3];
    className = $[4];
    counterSlots = $[5];
    defaultView = $[6];
    onChange = $[7];
    onClick = $[8];
    prefill = $[9];
    projectId = $[10];
    props = $[11];
    selectCallback = $[12];
    t1 = $[13];
    unitId = $[14];
    viewCounts = $[15];
  }
  const minSlots = t1 === undefined ? 1 : t1;
  let startTime;
  if ($[16] !== prefill) {
    startTime = prefill?.[0]?.start ? new Date(new Date(prefill[0].start)) : new Date();
    startTime.setHours(7, 0, 0, 0);
    $[16] = prefill;
    $[17] = startTime;
  } else {
    startTime = $[17];
  }
  let t2;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  const [selected, setSelected] = useState(t2);
  const [mounted, setMounted] = useState(false);
  const [date, setDate] = useState(startTime);
  const [viewCountsState, setViewCountsState] = useState(viewCounts);
  const {
    containerRef,
    containerWidth
  } = useContainerWidth();
  let t3;
  if ($[19] !== buyerSlots) {
    t3 = buyerSlots || [];
    $[19] = buyerSlots;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== t3 || $[22] !== unitId) {
    let t5;
    if ($[24] !== unitId) {
      t5 = slot => ({
        start: slot.startTime.toString(),
        end: slot.endTime.toString(),
        unitId
      });
      $[24] = unitId;
      $[25] = t5;
    } else {
      t5 = $[25];
    }
    t4 = t3.map(t5);
    $[21] = t3;
    $[22] = unitId;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  const buyerSlotsAsSlots = t4;
  let t5;
  if ($[26] !== prefill) {
    t5 = prefill || [];
    $[26] = prefill;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== buyerSlotsAsSlots || $[29] !== t5) {
    t6 = [...t5, ...buyerSlotsAsSlots];
    $[28] = buyerSlotsAsSlots;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  const allPrefill = t6;
  let t7;
  if ($[31] !== projectId || $[32] !== selectCallback || $[33] !== selected || $[34] !== unitId) {
    t7 = data => {
      if (!data) {
        logger.error("Selection of past date is not allowed");
        return;
      }
      const dataArray = Array.isArray(data) ? data : [data];
      let slotSelections = [];
      dataArray.forEach(d => {
        if (selected?.map(_temp).includes(d.start.toString())) {
          slotSelections.push(...selected.filter(el => el.start !== d.start.toString()));
        } else {
          slotSelections.push(...[...(selected || []), {
            start: d.start.toString(),
            end: d.end.toString(),
            unitId,
            projectId
          }]);
        }
      });
      slotSelections = slotSelections.filter(_temp2);
      slotSelections = Array.from(new Map(slotSelections.map(_temp3)).values());
      setSelected(slotSelections);
      if (selectCallback) {
        selectCallback(slotSelections);
      }
    };
    $[31] = projectId;
    $[32] = selectCallback;
    $[33] = selected;
    $[34] = unitId;
    $[35] = t7;
  } else {
    t7 = $[35];
  }
  const handleSelect = t7;
  let t8;
  let t9;
  if ($[36] !== allPrefill || $[37] !== handleSelect || $[38] !== mounted) {
    t8 = () => {
      if (allPrefill.length && !mounted) {
        handleSelect(allPrefill);
        setMounted(true);
      }
    };
    t9 = [handleSelect, mounted, allPrefill];
    $[36] = allPrefill;
    $[37] = handleSelect;
    $[38] = mounted;
    $[39] = t8;
    $[40] = t9;
  } else {
    t8 = $[39];
    t9 = $[40];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[41] !== containerWidth || $[42] !== viewCounts) {
    t10 = () => {
      if (containerWidth) {
        setViewCountsState(containerWidth < 640 ? 3 : viewCounts);
      }
    };
    t11 = [containerWidth, viewCounts];
    $[41] = containerWidth;
    $[42] = viewCounts;
    $[43] = t10;
    $[44] = t11;
  } else {
    t10 = $[43];
    t11 = $[44];
  }
  useEffect(t10, t11);
  const minButtonValidation = selected?.length < minSlots ? `Please provide at least ${minSlots} slots to increase visit confirmation chances.` : null;
  let buyerId;
  let loading;
  let openId;
  let restProps;
  let setLoading;
  let setOpenId;
  let userId;
  if ($[45] !== props) {
    ({
      userId,
      loading,
      openId,
      setOpenId,
      setLoading,
      buyerId,
      ...restProps
    } = props);
    $[45] = props;
    $[46] = buyerId;
    $[47] = loading;
    $[48] = openId;
    $[49] = restProps;
    $[50] = setLoading;
    $[51] = setOpenId;
    $[52] = userId;
  } else {
    buyerId = $[46];
    loading = $[47];
    openId = $[48];
    restProps = $[49];
    setLoading = $[50];
    setOpenId = $[51];
    userId = $[52];
  }
  let t12;
  if ($[53] !== buyerId || $[54] !== loading || $[55] !== openId || $[56] !== projectId || $[57] !== restProps || $[58] !== setLoading || $[59] !== setOpenId || $[60] !== userId) {
    t12 = {
      projectId,
      userId,
      loading,
      openId,
      setOpenId,
      setLoading,
      buyerId,
      ...restProps
    };
    $[53] = buyerId;
    $[54] = loading;
    $[55] = openId;
    $[56] = projectId;
    $[57] = restProps;
    $[58] = setLoading;
    $[59] = setOpenId;
    $[60] = userId;
    $[61] = t12;
  } else {
    t12 = $[61];
  }
  const calendarProps = t12;
  const isLoading = loading || viewCountsState === undefined;
  let t13;
  if ($[62] !== date || $[63] !== viewCountsState) {
    t13 = action => {
      const viewCountsNumber = viewCountsState || 7;
      let newDate = dayjs(date);
      bb98: switch (action) {
        case Navigate.PREVIOUS:
        case "PREV":
          {
            newDate = newDate.subtract(viewCountsNumber, "day");
            break bb98;
          }
        case Navigate.NEXT:
        case "NEXT":
          {
            newDate = newDate.add(viewCountsNumber, "day");
            break bb98;
          }
        case Navigate.TODAY:
        case "TODAY":
          {
            newDate = dayjs();
            break bb98;
          }
        default:
          {
            logger.error("Invalid action to navigate", {
              action
            });
            return;
          }
      }
      if (newDate.isValid()) {
        setDate(newDate.toDate());
      }
    };
    $[62] = date;
    $[63] = viewCountsState;
    $[64] = t13;
  } else {
    t13 = $[64];
  }
  const handleNavigate = t13;
  let t14;
  if ($[65] !== counterSlots || $[66] !== selected) {
    t14 = slotValue => {
      if (!slotValue) {
        return {
          selectedCounterSlots: false,
          selectedSlot: false,
          relationship: "buyer",
          slotValue: slotValue ?? ""
        };
      }
      const slotDate = typeof slotValue === "string" ? new Date(slotValue) : slotValue;
      const slotTime = slotDate.getTime();
      return {
        selectedCounterSlots: (counterSlots || []).map(_temp4).includes(slotTime),
        selectedSlot: (selected || []).filter(_temp5).map(_temp6).includes(slotTime),
        slotValue,
        relationship: "buyer"
      };
    };
    $[65] = counterSlots;
    $[66] = selected;
    $[67] = t14;
  } else {
    t14 = $[67];
  }
  const getSlotComponentProps = t14;
  const t15 = !selectCallback;
  const t16 = !className;
  let t17;
  if ($[68] !== className || $[69] !== selectCallback || $[70] !== t15 || $[71] !== t16) {
    t17 = clsx("cursor-pointer border-none rounded-lg shadow-none relative block w-full h-inherit overflow-y-auto bg-white", "scrollbar-thin scrollbar-thumb-pink-300 scrollbar-track-transparent", {
      rounded: selectCallback,
      "rounded-full": t15,
      "max-h-64": t16
    }, className);
    $[68] = className;
    $[69] = selectCallback;
    $[70] = t15;
    $[71] = t16;
    $[72] = t17;
  } else {
    t17 = $[72];
  }
  const t18 = `unit-request-visit-${unitId}-${projectId}`;
  const t19 = Title ?? null;
  const t20 = `slot-count-${selected.length}`;
  let t21;
  if ($[73] !== date) {
    t21 = date.toISOString();
    $[73] = date;
    $[74] = t21;
  } else {
    t21 = $[74];
  }
  let t22;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      className: "flex-1 flex flex-col min-h-0"
    };
    $[75] = t22;
  } else {
    t22 = $[75];
  }
  let t23;
  if ($[76] !== getSlotComponentProps) {
    t23 = t24 => {
      const {
        className: className_0,
        slotValue: slotValue_0
      } = t24;
      return <SlotComponent {...getSlotComponentProps(slotValue_0)} className={className_0} />;
    };
    $[76] = getSlotComponentProps;
    $[77] = t23;
  } else {
    t23 = $[77];
  }
  const t24 = defaultView as ViewType;
  let t25;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      hour: 22,
      minutes: 0
    };
    $[78] = t25;
  } else {
    t25 = $[78];
  }
  let t26;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = v => {
      setDate(v);
    };
    $[79] = t26;
  } else {
    t26 = $[79];
  }
  let t27;
  if ($[80] !== selected) {
    t27 = selected.map(_temp9);
    $[80] = selected;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  let t28;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      hour: 7,
      minutes: 0
    };
    $[82] = t28;
  } else {
    t28 = $[82];
  }
  let t29;
  if ($[83] !== minSlots || $[84] !== selected.length) {
    t29 = () => <TitleComp isVisible={selected?.length < minSlots} minSlots={minSlots} />;
    $[83] = minSlots;
    $[84] = selected.length;
    $[85] = t29;
  } else {
    t29 = $[85];
  }
  let t30;
  if ($[86] !== handleNavigate || $[87] !== t29) {
    t30 = {
      TitleComp: t29,
      onNavigate: handleNavigate
    };
    $[86] = handleNavigate;
    $[87] = t29;
    $[88] = t30;
  } else {
    t30 = $[88];
  }
  const t31 = isLoading ? 3 : viewCountsState;
  const t32 = props.views;
  let t33;
  if ($[89] !== date) {
    t33 = new Date(date).getDay();
    $[89] = date;
    $[90] = t33;
  } else {
    t33 = $[90];
  }
  let t34;
  if ($[91] !== calendarProps || $[92] !== date || $[93] !== handleSelect || $[94] !== props.views || $[95] !== t21 || $[96] !== t23 || $[97] !== t24 || $[98] !== t27 || $[99] !== t30 || $[100] !== t31 || $[101] !== t33) {
    t34 = <Calendar key={t21} ContainerProps={t22} CustomSlotComponent={t23} defaultDate={date} defaultView={t24} endTime={t25} noSelectionOfPastDate={true} onNavigate={t26} onSelectSlot={handleSelect} onSelecting={_temp8} selected={t27} slotCount={2} slotDuration={60} startTime={t28} toolbarProps={t30} viewCounts={t31} views={t32} startWeekDay={t33} {...calendarProps} />;
    $[91] = calendarProps;
    $[92] = date;
    $[93] = handleSelect;
    $[94] = props.views;
    $[95] = t21;
    $[96] = t23;
    $[97] = t24;
    $[98] = t27;
    $[99] = t30;
    $[100] = t31;
    $[101] = t33;
    $[102] = t34;
  } else {
    t34 = $[102];
  }
  let t35;
  if ($[103] !== t20 || $[104] !== t34) {
    t35 = <div className="w-full relative flex-1 flex flex-col" onTouchStart={_temp7} data-testid={t20}>{t34}</div>;
    $[103] = t20;
    $[104] = t34;
    $[105] = t35;
  } else {
    t35 = $[105];
  }
  let t36;
  if ($[106] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <div className="flex flex-col items-center gap-2"><SlotTableLegend items={[{
        title: "Seller Slots",
        selectedCounterSlots: true,
        relationship: "buyer"
      }, {
        title: "Your Slots",
        selectedSlot: true,
        relationship: "buyer"
      }, {
        title: "Matching Slots",
        selectedCounterSlots: true,
        selectedSlot: true,
        relationship: "buyer"
      }]} /></div>;
    $[106] = t36;
  } else {
    t36 = $[106];
  }
  let t37;
  if ($[107] !== containerRef || $[108] !== restProps || $[109] !== t17 || $[110] !== t18 || $[111] !== t19 || $[112] !== t35) {
    t37 = <div data-testid="slot-visit-container" className={t17} data-name={t18} id="slotvisit" {...restProps} ref={containerRef}>{t19}{t35}{t36}</div>;
    $[107] = containerRef;
    $[108] = restProps;
    $[109] = t17;
    $[110] = t18;
    $[111] = t19;
    $[112] = t35;
    $[113] = t37;
  } else {
    t37 = $[113];
  }
  let t38;
  if ($[114] !== TableLegend || $[115] !== minButtonValidation || $[116] !== minSlots || $[117] !== onChange || $[118] !== onClick || $[119] !== selectCallback || $[120] !== selected) {
    t38 = !selectCallback && <div className="flex py-3 sticky bottom-0 z-10 justify-between items-center bg-white">{TableLegend ? <TableLegend /> : <button className="px-4 py-2 text-primary-700 hover:text-primary-700 text-sm font-medium bg-white" onClick={() => onClick?.()}>Cancel</button>}<p className="text-center w-64 text-sm font-bold md:text-base">{selected.length ? `${selected.length} slot${selected.length > 1 ? "s" : ""} selected` : ""}</p><span {...minButtonValidation && {
        onClick: _temp10
      }} title={minButtonValidation ?? ""}><button className={clsx("px-4 py-2 rounded text-sm font-medium transition-colors", selected?.length < minSlots ? "bg-gray-300 text-gray-500 cursor-not-allowed" : "bg-primary text-white hover:bg-primary")} data-testid="slot-visit-submit-button" disabled={selected?.length < minSlots} onClick={() => {
          onChange?.(selected);
          onClick?.();
        }}>Submit</button></span></div>;
    $[114] = TableLegend;
    $[115] = minButtonValidation;
    $[116] = minSlots;
    $[117] = onChange;
    $[118] = onClick;
    $[119] = selectCallback;
    $[120] = selected;
    $[121] = t38;
  } else {
    t38 = $[121];
  }
  let t39;
  if ($[122] !== t37 || $[123] !== t38) {
    t39 = <>{t37}{t38}</>;
    $[122] = t37;
    $[123] = t38;
    $[124] = t39;
  } else {
    t39 = $[124];
  }
  return t39;
}
function _temp10() {
  return logger.error("");
}
function _temp9(slot_0) {
  return {
    ...slot_0,
    start: typeof slot_0.start === "string" ? slot_0.start : slot_0.start.toISOString(),
    end: typeof slot_0.end === "string" ? slot_0.end : slot_0.end.toISOString()
  };
}
function _temp8() {
  return false;
}
function _temp7(e) {
  return e.stopPropagation();
}
function _temp6(el_4) {
  return new Date(el_4.start).getTime();
}
function _temp5(el_3) {
  return new Date(el_3.start) > new Date();
}
function _temp4(el_2) {
  return new Date(el_2.start).getTime();
}
function _temp3(item) {
  return [item.start, item];
}
function _temp2(el_1) {
  return new Date(el_1.start) > new Date();
}
function _temp(el_0) {
  return el_0.start;
}